import { Component } from 'react';
import PropTypes from 'prop-types';
import { getDateStringFromState, getStateFromDateString } from '../../utils/datetimeUtils';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default class DateInput extends Component {
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  constructor(props) {
    super(props);
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.onChange = ({
      target: {
        value
      }
    }) => {
      this.setState({
        date: value
      });
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      this.props.onChange(getDateStringFromState({
        date: value
      }));
    };
    this.state = getStateFromDateString(this.props.value);
  }

  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

  render() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      disabled,
      id,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx(UIDateInput, {
      disabled: disabled,
      id: `${id}-date`,
      onChange: this.onChange,
      readOnly: readOnly
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
      value: this.state.date
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
DateInput.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  value: PropTypes.string
};